export const getRenewalProductCodes = () => ['FPR', 'NPOR', 'CSPAR', 'CSSR'];
